import axios from "axios";
import * as types from "./types";

export default {
  [types.OPEN_NEW_FRANCHISE_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_NEW_FRANCHISE_SIDEBAR, { ...payload, visible: true });
  },
  [types.OPEN_NEW_PHYSICAL_FRANCHISE_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_NEW_PHYSICAL_FRANCHISE_SIDEBAR, {
      ...payload,
      visible: true,
    });
  },
  [types.GET_DIGITAL_FRANCHISE]: ({}, payload) => {
    return axios
      .get(`/api/digital_franchises/${payload.id}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_PHYSICAL_FRANCHISE]: ({}, payload) => {
    return axios
      .get(`/api/physical_franchises/${payload.id}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.SEARCH_DIGITAL_FRANCHISES]: ({ commit }, payload) => {
    const resource = `/api/digital_franchises/search?page=${payload.currentPage}`;
    delete payload.currentPage;
    return axios
      .post(resource, payload)
      .then((resp) => {
        commit(types.MUTATE_DIGITAL_FRANCHISES_RESULT, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.SEARCH_PHYSICAL_FRANCHISES]: ({ commit }, payload) => {
    const resource = `/api/physical_franchises/search?page=${payload.currentPage}`;
    delete payload.currentPage;
    return axios
      .post(resource, payload)
      .then((resp) => {
        commit(types.MUTATE_PHYSICAL_FRANCHISES_RESULT, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.STORE_FRANCHISE]: ({}, payload) => {
    return axios
      .post(`/api/digital_franchises`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.STORE_PHYSICAL_FRANCHISE]: ({}, payload) => {
    return axios
      .post(`/api/physical_franchises`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.EDIT_FRANCHISE]: ({}, payload) => {
    return axios
      .post(`/api/digital_franchises/${payload.id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.EDIT_PHYSICAL_FRANCHISE]: ({}, payload) => {
    return axios
      .post(`/api/physical_franchises/${payload.id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.OPEN_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR, { ...payload, visible: true });
  },
  [types.GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES]: ({ commit }) => {
    return axios
      .get(`/api/digital_franchise_purchases/franchise_types`)
      .then((resp) => {
        commit(types.MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS]: ({ commit }) => {
    return axios
      .get(`/api/digital_franchise_purchases/status_types`)
      .then((resp) => {
        commit(types.MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.SAVE_DIGITAL_FRANCHISE_PURCHASE]: ({}, payload) => {
    return axios
      .post(`/api/digital_franchise_purchases`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.UPDATE_DIGITAL_FRANCHISE_PURCHASE]: ({}, payload) => {
    return axios
      .put(`/api/digital_franchise_purchases/${payload.id}`, payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.SEARCH_DIGITAL_FRANCHISES_PURCHASE]: ({ commit }, payload) => {
    const resource = `/api/digital_franchise_purchases/search?page=${payload.currentPage}`;
    delete payload.currentPage;
    return axios
      .post(resource, payload)
      .then((resp) => {
        commit(types.MUTATE_DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
   [types.GET_DIGITAL_FRANCHISE_PURCHASE]: ({ }, payload) => {
    return axios
      .get(`/api/digital_franchise_purchases/${payload}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
};
